<template>
  <Brands
    :title="mgnlProps?.title ?? ''"
    :brand-image="mgnlProps?.brandImage"
  />
</template>

<script lang="ts" setup>
import Brands from '~/components/Footer/Brands/Brands.vue';
import { BrandsBuilder, WrapperProps } from '~/components/Footer/Brands/Brands.model';

const props = defineProps(WrapperProps);
const mgnlProps = BrandsBuilder.build(props);
</script>
